import { connect } from "react-redux";
import SalaryMaster from './SalaryMaster';
import { bindActionCreators } from "redux";
import {getInfraIDForValet, getMonthlyDataForValet, calculateSalaryForValet, updateSalaryStatusForValet} from "../../../services/redux/Valet/Project/action";
const mapStateToProps = (state) => ({
    getValetMonthlyList: state.CreateProject.getValetMonthlyList,
    calulateSalary: state.CreateProject.calculateSalary
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getInfraIDForValet,
        getMonthlyDataForValet,
        calculateSalaryForValet,
        updateSalaryStatusForValet
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SalaryMaster);
